import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  MenuItem,
  Chip,
  Box,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditItemView from '../common/components/EditItemView';
import { useTranslation } from '../common/components/LocalizationProvider';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  details: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  chipsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

const ClientPage = () => {
  const classes = useStyles();
  const t = useTranslation();
  const [item, setItem] = useState({ produits: [] });

  const products = useSelector((state) => state.products.items);

  const validate = () => item && item.username && item.email && item.phone;

  // Retourne "Nom - Référence"
  const getProductLabel = (prod) => `${prod.designation || 'N/A'} - ${prod.reference || 'N/A'}`;

  return (
    <EditItemView
      endpoint="clients"
      item={item}
      setItem={setItem}
      validate={validate}
    >
      {item && (
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1">{t('sharedRequired')}</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.details}>
            <TextField
              value={item.username || ''}
              onChange={(e) => setItem({ ...item, username: e.target.value })}
              label="Nom complet"
              required
            />
            <TextField
              value={item.email || ''}
              onChange={(e) => setItem({ ...item, email: e.target.value })}
              label="Adresse e-mail"
              type="email"
              required
            />
            <TextField
              value={item.phone || ''}
              onChange={(e) => setItem({ ...item, phone: e.target.value })}
              label="Téléphone"
              required
            />
            <TextField
              value={item.adresse || ''}
              onChange={(e) => setItem({ ...item, adresse: e.target.value })}
              label="Adresse"
            />

            <TextField
              select
              SelectProps={{ multiple: true }}
              value={item.produits?.map((p) => p._id) || []}
              onChange={(e) => {
                const selected = e.target.value.map((id) => products.find((p) => p._id === id));
                setItem({ ...item, produits: selected });
              }}
              label="Produits"
            >
              {products.map((prod) => (
                <MenuItem key={prod._id} value={prod._id}>
                  {getProductLabel(prod)}
                </MenuItem>
              ))}
            </TextField>

            {/* Affichage sous forme de chips */}
            <Box className={classes.chipsContainer}>
              {item.produits?.map((prod) => (
                <Chip key={prod._id} label={getProductLabel(prod)} />
              ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
    </EditItemView>
  );
};

export default ClientPage;
